const landing = {
  logoButtonLabel: 'Begin TOF Persona',
  logoAlt: 'TOF logo',
  subtitle: 'Inzicht in werkstijl, teamdynamiek en werkplek.',
  languageLabel: 'Kies je taal',
  cta: 'Begin bij jezelf  →',
};

export default landing;
